import React from 'react';
import { Table, Icon, Button, Modal, Popconfirm, message, Upload } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import ModalSubject from '../../components/ModalSubject'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import moment from 'moment';


class SchoolAdminSubject extends React.Component {

  state= {
    modalOpen: false
  }

  saveModal = (data) => {
    const { t } = this.props
    this.setState({modalOpen: false})
    const { subjectCategory, subjectName } = data
    const { subjects } = this.props
    const addedSubject = subjects && Object.entries(subjects).filter( subject =>
      subject[1].name == subjectName
    )
    if (addedSubject && addedSubject.length == 0) {
      this.props.firebase.database().ref('/subjects').push({
        name: subjectName,
        category: subjectCategory,
        readOnly: false
      }).then(() => message.success('Subject added'))
    } else {
      message.warning(t('Subject already exists'))
    }

  }

  getTableData = () => {
    const { t } = this.props
    if (this.props.subjects && this.props.subject_categories) {
      const subject_categories = this.props.subject_categories
      const subjects = Object.entries(this.props.subjects)
      let tableData = []
      subjects.map( subject => {
        if (!subject[1].readOnly) {
          let item = {
            key: subject[0],
            id: subject[0],
            subject: t(subject[1].name),
            category: t(subject_categories[subject[1].category].name)
          }
          tableData.push(item)
        }
      })
      return tableData

    }
  }

  render() {

    const { t } = this.props;
    const columns = [
            {
              title: t('Subject group'),
              dataIndex: 'category',
              key: 'category',
            },
            {
              title: t('Subject'),
              dataIndex: 'subject',
              key: 'subject',
            },

    ]

    return (
      <div>
        <div style={styles.container} className='schoolAdmin'>
          <div style={styles.submenu}>
            <Button
              onClick={() => this.setState({modalOpen: true})}
              style={styles.buttonBlue} type="primary"
            >
              <Icon type="book"/>{t('Add Subject')}
            </Button>
          </div>
          <div style={styles.inner}>
            <h3 style={{fontSize: 22, fontWeight: 'bold', marginLeft: 5}}>{t('Subjects')}</h3>
            <Table
              id='log-table'
              size='small'
              pagination={false}
              columns={columns}
              dataSource={this.getTableData()}
            />
          </div>
        </div>
        <ModalSubject
          open={this.state.modalOpen}
          save={this.saveModal}
          close={() => this.setState({modalOpen: false})}
          subject_categories={this.props.subject_categories}
          t={this.props.t}
        />
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'subject_categories', 'subjects'
    ]
  }),
  connect(
    state => ({
      subject_categories: state.firebase.data.subject_categories,
      subjects: state.firebase.data.subjects,
    })
  )
)
export default enhancer(SchoolAdminSubject);

const styles = {

  container: {
    padding: '20px',
  },

  buttonBlue: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px',
  },

  submenu: {
    marginBottom: '20px',
    overflow: 'hidden'
  },

  inner: {
    padding: 20,
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)',
    marginBottom: 80
  }
}



// WEBPACK FOOTER //
// ./src/containers/SchoolAdminSubject/index.jsx